import { render, staticRenderFns } from "./EditObjects.vue?vue&type=template&id=4958a2b6&scoped=true"
import script from "./EditObjects.vue?vue&type=script&lang=js"
export * from "./EditObjects.vue?vue&type=script&lang=js"
import style0 from "./EditObjects.vue?vue&type=style&index=0&id=4958a2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958a2b6",
  null
  
)

export default component.exports